import $http from '../http'
import { baseUrl } from '../url'
const BASEURL = baseUrl.primary + '/v2'
const BASEURL_DEV = BASEURL + '/Position'

const posts = {
  // getPosts(params) {
  //   return $http({
  //     method: 'get',
  //     url: `${BASEURL}/PositionManagement/PageList`,
  //     params
  //   })
  // },
  ApplyPositionPageData(data) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/ApplyPositionPageData`,
     data
    })
  },
  PositionAllList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/PositionAllList`,
      params
    })
  },
  PositionList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/PositionList`,
      params
    })
  },
  PositionTypeBtachDelete(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/PositionTypeBtachDelete`,
      data
    })
  },
  BatchUpdateStopState(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/BatchUpdateStopState`,
      data
    })
  },
  PositionBtachDelete(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/PositionBtachDelete`,
      data
    })
  },
  PositionStatisticsData(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/PositionStatisticsData`,
      params
    })
  },
  PositionTypeDelete(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/PositionTypeDelete`,
      data
    })
  },
  EditPositionTypeSort(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/EditPositionTypeSort`,
      data
    })
  },
  PositionTypeDetail(id) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/PositionTypeDetail?id=${id}`
    })
  },
  PositionTypePage(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/PositionTypePage`,
      params
    })
  },
  PositionTypeEdit(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/PositionTypeEdit`,
      data
    })
  },

  getPosts(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/Page_v2`,
      params,
    })
  },
  UpdateTime(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/UpdateTime`,
      data
    })
  },
  getPerk(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/SubsidyPage`,
      params
    })
  },
  addPerk(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/SubsidyEdit`,
      data
    })
  },
  delPerk(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/SubsidyDelete`,
      data
    })
  },
  postsSort(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/EditSort`,
      data
    })
  },
  changePostsState(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/PositionManagement/EditPositionState?state=${data.key}`,
      data: data.ids
    })
  },
  // deletePosts(data) {
  //   return $http({
  //     method: 'post',
  //     url: `${BASEURL}/PositionManagement/Delete`,
  //     data
  //   })
  // },
  deletePosts(data) {
    // 沈帅
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/Delete`,
      data
    })
  },
  // increasePosts(data) {
  //   return $http({
  //     method: 'post',
  //     url: `${BASEURL}/PositionManagement/EditPosition`,
  //     data
  //   })
  // },

  // Naze 添加职位
  increasePosts(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/Edit`,
      data
    })
  },

  getPostsClassSummaryData() {
    // return $http({
    //   method: "get",
    //   url: `${BASEURL}/PositionManagement/PositionStateCollect`,
    // });
  },
  // getPostDetails(id) {
  //   return $http({
  //     method: "get",
  //     url: `${BASEURL}/PositionManagement/PositionDetail?id=${id}`,
  //   });
  // },
  getPostDetails(id) {
    // 沈帅
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/Detail?id=${id}`
    })
  },
  getPostCandidates(params) {
    // return $http({
    //   method: "get",
    //   url: `${BASEURL}/PositionCandidate/PageList`,
    //   params,
    // });
  },
  addPostCandidates(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/PositionCandidate/Edit`,
      data
    })
  },
  removePostCandidates(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/PositionCandidate/Delete`,
      data
    })
  },
  changeCandidatesState(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/PositionCandidate/UpdateState?state=${data.state}&stateValue=${data.stateValue}&parentState=${data.parentState}&parentValue=${data.parentValue}&stateName=${data.stateName}&parentName=${data.parentName}`,
      data: data.ids
    })
  },
  getCandidateStateClassify(id) {
    return $http({
      method: 'get',
      url: `${BASEURL}/PositionCandidate/StateClassification?positionId=${id}`
    })
  },
  getCompanyPostsList(id, state) {
    return $http({
      method: 'get',
      url: `${BASEURL}/PositionManagement/GetPositionList?customerId=${id}&state=${state}`
    })
  },
  getNotChangeStateCandidate() {
    // return $http({
    //   method: "get",
    //   url: `${BASEURL}/PositionCandidate/NotChangeState`,
    // });
  },
  addAccessory(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/PositionManagement/AddAccessory`,
      data
    })
  },
  deleteAccessory(id) {
    return $http({
      method: 'post',
      url: `${BASEURL}/PositionManagement/DeleteAccessory?accId=${id}`
    })
  },
  addServiceInfo(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/PositionPerformance/EditPerformance`,
      data
    })
  },
  getServiceInfo(id) {
    return $http({
      method: 'get',
      url: `${BASEURL}/PositionPerformance/GetPerformanceDetail?id=${id}`
    })
  },
  // Naze 单个删除职位
  deleteposition(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/Delete`,
      data: data
    })
  },

  GetPositionByCid(id) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/GetPositionByCid?customerId=${id}`
    })
  },

  // Naze 单个修改职位状态
  updatePositionState(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/UpdateStopState`,
      data: data
    })
  }
}

export default posts
